import React, {Fragment, useEffect, useState} from "react";
import DataTable from "react-data-table-component";
import {useDispatch, useSelector} from "react-redux";
import {Link, useRouteMatch} from "react-router-dom";
import ApiConnect from "../../../../Utils/ApiConnect";
import DeletePop from "../../../Components/DeletePop";
import FileViewer from "../../../Components/FileViewer";

export default function ViewProduct(props) {
  const productList = useSelector((state) => state.Inventory.Products);
  const CategoryList = useSelector((state) => state.Inventory.Category);
  const GodownList = useSelector((state) => state.Inventory.Godown);
  const BrandList = useSelector((state) => state.Inventory.Brands);
  const { url } = useRouteMatch();
  const [selectedId, SetselectedId] = useState(false);
  const [showModal, Setmodal] = useState(false);
  const [selectedFile, SetselectedFile] = useState(false);
  const [triggerModal, SettriggerModal] = useState(false);
  const [selectedBrand, setSelectBrand] = useState("");
  const [selectedGodown, setSelectGodown] = useState("");
  const [selectedCategory, setSelectCategory] = useState("");
  const [filterText, setFilterText] = useState("");
  const dispatch = useDispatch();
  const columns = [
    {
      name: "Product Name",
      selector: row => row.name,
      width: "450px",
      sortable: true,
      cell: (row) => {
        return (
          <div className="media d-inline-flex">
            <img
              className="avatar avatar-lg"
              src={row.image[0]}
              alt={row.name}
              onClick={() => {
                SetselectedFile(row.image[0]);
                Setmodal(true);
              }}
            />
            <div className="media-body">
              <p className="lh-1">{row.name}</p>
              <small>{row.id}</small>
            </div>
          </div>
        );
      },
    },
    {
      name: "Category",
      selector: row => row.category,
      sortable: true,
    },
    {
      name: "Godown",
      selector: row => row.store,
      sortable: true,
    },
    {
      name: "Brand",
      selector: row => row.brand,
      sortable: true,
      cell: (row) => {
        return <>{row.brand ? row.brand.name : ""}</>;
      },
    },
    {
      name: "Stock",
      selector: row => row.stock,
      sortable: true,
      cell: (row) => {
        return (
          <p className="d-flex">
            {row.stock}
            {row.stock <= row.minqty ? (
              row.stock < 0 ? (
                <span className="material-icons text-warning">warning</span>
              ) : (
                <span className="material-icons text-danger">
                  priority_high
                </span>
              )
            ) : (
              ""
            )}
          </p>
        );
      },
    },
    {
      name: "U.Stock",
      selector: row => row.unit,
      sortable: true,
      cell: (row) => {
        return (
          <React.Fragment>
            {row.stock * row.size}
            {row.unit}
          </React.Fragment>
        );
      },
    },
    {
      name: "S.Price",
      selector: row => row.price,
      sortable: true,
    },
    {
      name: "LP.Rate",
      selector: row => row.cprice,
      sortable: true,
    },
    {
      name: "Margin",
      selector: row => row.margin,
      sortable: true,
      cell: (row) => {
        return (
          <React.Fragment>
            {(((row.price - row.cprice) * 100) / row.cprice).toFixed(
              2
            )}
            %
          </React.Fragment>
        );
      },
    },
    {
      name: "Action",
      selector: row => row.action,
      className: "table-actions",
      width: "150px",
      sortable: false,
      cell: (row) => {
        return (
          <React.Fragment>
            <Link
              className="table-action btn btn-square btn-pure hover-warning"
              to={`${url}/View/${row.id}`}
            >
              <span className="material-icons-outlined">visibility</span>
            </Link>
            <Link
              className="table-action btn btn-square btn-pure hover-warning"
              to={`${url}/Edit/${row.id}`}
            >
              <span className="material-icons-outlined">edit_note</span>
            </Link>
            <button
              disabled={false}
              className="table-action btn btn-square btn-pure hover-danger"
              onClick={() => {
                SetselectedId(row.id);
                SettriggerModal(true);
              }}
            >
              <span className="material-icons-outlined">delete</span>
            </button>
          </React.Fragment>
        );
      },
    },
    ];

  const customStyles = {
    headCells: {
      style: {
        padding: "12px 16px",
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#f8f9fa",
      },
    },
    cells: {
      style: {
        padding: "10px 16px",
        fontSize: "13px",
      },
    },
  };

  const filteredData = (productList || []).filter(
    item =>
      Object.values(item).some(val =>
        String(val).toLowerCase().includes(filterText.toLowerCase())
      )
  );

  useEffect(() => {
    if (props.location.state !== null) {
      fetchProducts();
    }
    fetchInventory();
  }, []);

  const fetchProducts = () => {
    ApiConnect.get(
      `/Module/Inventory/Product/Details?category=${selectedCategory}&godown=${selectedGodown}&brand=${selectedBrand}`
    )
      .then((response) => {
        let Products = response.data;
        dispatch({ type: "SET_INVENTORY_PRODUCTS", payload: { Products } });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const fetchInventory = () => {
    ApiConnect.get("/Module/Inventory/Product/Components")
      .then((response) => {
        let Godown = response.data.godown;
        let Brand = response.data.brand;
        let Category = response.data.category;
        dispatch({ type: "SET_INVENTORY_GODOWN", payload: { Godown } });
        dispatch({
          type: "SET_INVENTORY_BRANDS",
          payload: { Brand },
        });
        dispatch({
          type: "SET_INVENTORY_CATEGORY",
          payload: { Category },
        });
      })
      .catch((error) => console.log(error));
  };
  const SetviewerTrigger = () => {
    Setmodal(false);
  };
  return (
    <div className="col-md-12 col-xl-12">
      <div className="card">
        <div className="card-body">
          <div className="row justify-content-center">
            <div className="form-group col-md-3">
              <label>Category</label>
              <select
                value={selectedCategory}
                className="form-control"
                onChange={(e) => setSelectCategory(e.target.value)}
              >
                <option value="">Select Category</option>
                {CategoryList.map((cat, catind) => (
                  <option value={cat.catid} key={catind}>
                    {cat.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group col-md-3">
              <label>Brand</label>
              <select
                className="form-control"
                value={selectedBrand}
                onChange={(e) => setSelectBrand(e.target.value)}
              >
                <option value="">Select Brand</option>
                {BrandList.map((brd, brdind) => (
                  <option value={brd.id} key={brdind}>
                    {brd.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group col-md-3">
              <label>Godown</label>
              <select
                className="form-control"
                value={selectedGodown}
                onChange={(e) => setSelectGodown(e.target.value)}
              >
                <option value="">Select Godown</option>
                {GodownList.map((gdm, gdmind) => (
                  <option value={gdm.godownid} key={gdmind}>
                    {gdm.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group col-md-3">
              <br />
              <button className="btn btn-secondary col">Reset</button>
              <button
                className="btn btn-primary col"
                onClick={() => fetchProducts()}
              >
                Fetch
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="dataTables_wrapper">
            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                onChange={e => setFilterText(e.target.value)}
              />
            </div>
            <DataTable
              className="table table-separated table-responsive"
              keyField="id"
              columns={columns}
              data={filteredData}
              pagination
              paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
              paginationPerPage={10}
              customStyles={customStyles}
              filter
              exportable
            />
          </div>
          <DeletePop
            trigger={triggerModal}
            delUrl={`/Module/Inventory/Product/DeleteProduct?id=${selectedId}`}
            hideTrigger={SettriggerModal}
            fallAction={fetchProducts}
          />
          <FileViewer
            trigger={showModal}
            doc={selectedFile}
            hideTrigger={SetviewerTrigger}
          />
        </div>
      </div>
    </div>
  );
}
